module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia8-0e84f04a8405bb096d63593d353574b5.jpg";